export default "__VITE_ASSET__COXBnnwg__"